import { useTravelCurrencyAllowlist } from '@shared/hooks/useTravelCurrencyAllowlist';

type UseIsTravelCurrencyFundArgs = Readonly<{
  currencyCodes: ReadonlyArray<string | null | undefined>;
  skip: boolean;
}>;

// True when every known fund currency is one honeymoon travel can price in — the same list the other honeymoon promos use.
export const useIsTravelCurrencyFund = ({ currencyCodes, skip }: UseIsTravelCurrencyFundArgs): boolean => {
  const { allowedSet: travelCurrencyCodes } = useTravelCurrencyAllowlist({ skip });
  return currencyCodes.every(currencyCode => !currencyCode || travelCurrencyCodes.has(currencyCode.toUpperCase()));
};
